var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgThIconMenuExpand(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2 0H0V20H2V11H16.17L10.67 16.5L12.08 17.92L20 10L12.08 2.08L10.67 3.5L16.17 9H2V0Z",
    fill: "#97E0BC"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgThIconMenuExpand);
export default __webpack_public_path__ + "static/media/TH-Icon-Menu-Expand.47b3236b7d0dd0e3af479a71408bf768.svg";
export { ForwardRef as ReactComponent };